<template>
     <div class="draggable-item-content-container">
        <div class="draggable-item-container" @click="openMenu">
                <ProductionOrderCardContent
                    :orderReference="orderReference"
                    :isThereOrInProductionAtProductionLine="isThereOrInProductionAtProductionLine"
                    :canOpenMenu="true"
                ></ProductionOrderCardContent>
        </div>
        <transition name="slide-fade">
            <ProductionOrderCardMenu
                v-if="showMenu"
                :orderReference="orderReference" 
                :isThereOrInProductionAtProductionLine="isThereOrInProductionAtProductionLine" 
                @closeMenu="closeMenu"
            />
        </transition>
     </div>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.common.js";
import ProductionOrderCardContent from "./ProductionOrderCardMenu/ProductionOrderCardContent.vue";
import ProductionOrderCardMenu from "./ProductionOrderCardMenu/ProductionOrderCardMenu.vue";
export default {
    name: "ProductionOrderCard",
    components: {
        ProductionOrderCardContent,
        ProductionOrderCardMenu,
    },
    props:{
        orderReference: {
            type: Object,
            default: {}
        },
        isThereOrInProductionAtProductionLine: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            showMenu: false,
        }
    },
    methods: {
        ...mapActions('production_control', ['setIsMenuShowing']),
        openMenu() {
            this.setIsMenuShowing(true);
            this.showMenu = true;
        },
        closeMenu() {
            this.setIsMenuShowing(false);
            this.showMenu = false;
        },
    },
}
</script>